<template>
  <div class="default-modal address-modal">
    <button type="button" class="default-modal__close" @click="$emit('close')">
      <IconComponent name="add" />
    </button>
    <div class="default-modal__body address-modal__body">
      <ClientOnly v-if="mapReady">
        <yandex-map
          :settings="settings"
          :options="options"
          :coords="coords"
          zoom="12"
          @click="getLocation"
          @map-was-initialized="init"
        >
          <!--          <ymap-marker :coords="coords" marker-id="123" marker-type="placemark">-->
          <!--            <div slot="balloon">адрес</div>-->
          <!--          </ymap-marker>-->
        </yandex-map>
      </ClientOnly>
      <AddressCreateForm
        :address="address"
        :premiseNumber="premiseNumber"
        :editAddress="editAddress"
        @close="$emit('close')"
        @address-input="geocodeAddress"
      />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import { loadYmap, yandexMap, ymapMarker } from "vue-yandex-maps";
import AddressCreateForm from "@/views/user/pages/address/components/AddressCreateForm.vue";
import ClientOnly from "vue-client-only";

export default {
  name: "AddressModal",
  props: {
    editAddress: Object,
  },
  data() {
    return {
      mapReady: false,
      voteAccepted: false,
      voteError: false,
      coords: [42.967631, 47.503442],
      marker: null,
      map: null,
      address: null,
      premiseNumber: null,
      settings: {
        apiKey: "c5ba8ad1-d002-49b3-ae67-db98ac46c0ed",
        lang: "ru_RU",
        coordorder: "latlong",
        version: "2.1",
      },
      // icon: {
      //   layout: "default#imageWithContent",
      //   imageHref: "/static/images/map-red-location.png",
      //   imageSize: [32, 36],
      //   imageOffset: [-18, -18],
      // },
      options: {
        suppressMapOpenBlock: true,
        suppressObsoleteBrowserNotifier: true,
        yandexMapDisablePoiInteractivity: true,
      },
    };
  },
  created() {
    loadYmap({
      ...this.settings,
    }).then(() => {
      window.ymaps.ready(this.init);
      this.mapReady = true;
      // Если редактируем адрес - устанавливаем начальные значения
      if (this.editAddress) {
        this.address = this.editAddress.address;
        this.premiseNumber = this.editAddress.address ? '1' : null; // Для активации формы
        // Геокодируем адрес для отображения на карте
        this.$nextTick(() => {
          if (this.editAddress.address) {
            this.geocodeAddress(this.editAddress.address);
          }
        });
      }
    });
  },
  methods: {
    init(map) {
      this.map = map;
      // поставить обработчик на событие поиска
      if (this.map.controls) {
        this.map.controls.remove("searchControl");
        this.map.controls.get("geolocationControl").options.set({
          float: "right",
        });
      }
    },
    getLocation(e) {
      this.coords = e.get("coords");
      // Если метка уже создана – просто передвигаем ее.
      if (this.marker) {
        this.marker.geometry.setCoordinates(this.coords);
      }
      // Если нет – создаем.
      else {
        this.marker = this.createPlacemark(this.coords);
        this.map.geoObjects.add(this.marker);
        // Слушаем событие окончания перетаскивания на метке.
        this.marker.events.add("dragend", () => {
          this.getAddress(this.marker.geometry.getCoordinates());
        });
      }
      this.getAddress(this.coords);
    },
    createPlacemark(coords) {
      return new window.ymaps.Placemark(
        coords,
        {
          iconCaption: "поиск...",
        },
        {
          preset: "islands#violetDotIconWithCaption",
          draggable: true,
        }
      );
    },
    // Определяем адрес по координатам (обратное геокодирование).
    getAddress(coords) {
      this.marker.properties.set("iconCaption", "поиск...");
      window.ymaps.geocode(coords).then((res) => {
        let firstGeoObject = res.geoObjects.get(0);
        this.premiseNumber = firstGeoObject.getPremiseNumber();
        this.address = firstGeoObject.getAddressLine();
        let shortAddress = [
          firstGeoObject.getThoroughfare(),
          firstGeoObject.getPremiseNumber(),
          firstGeoObject.getPremise(),
        ]
          .filter(Boolean)
          .join(", ");
        this.marker.properties.set({
          // Формируем строку с данными об объекте.
          iconCaption: shortAddress,
          // В качестве контента балуна задаем строку с адресом объекта.
          balloonContent: this.address,
        });
      });
    },
    // Геокодирование по введенному адресу (прямое геокодирование).
    geocodeAddress(addressString) {
      if (!addressString || addressString.length < 5) return;
      window.ymaps.geocode(addressString).then((res) => {
        let firstGeoObject = res.geoObjects.get(0);
        if (!firstGeoObject) return;
        this.coords = firstGeoObject.geometry.getCoordinates();
        this.premiseNumber = firstGeoObject.getPremiseNumber();
        // Если метка уже создана – просто передвигаем ее.
        if (this.marker) {
          this.marker.geometry.setCoordinates(this.coords);
        }
        // Если нет – создаем.
        else {
          this.marker = this.createPlacemark(this.coords);
          this.map.geoObjects.add(this.marker);
          // Слушаем событие окончания перетаскивания на метке.
          this.marker.events.add("dragend", () => {
            this.getAddress(this.marker.geometry.getCoordinates());
          });
        }
        let shortAddress = [
          firstGeoObject.getThoroughfare(),
          firstGeoObject.getPremiseNumber(),
          firstGeoObject.getPremise(),
        ]
          .filter(Boolean)
          .join(", ");
        this.marker.properties.set({
          iconCaption: shortAddress,
          balloonContent: addressString,
        });
        // Центрируем карту на найденной точке
        this.map.setCenter(this.coords, 16);
      });
    },
  },
  components: { AddressCreateForm, IconComponent, yandexMap, ymapMarker, ClientOnly },
};
</script>

<style lang="stylus">
.address-modal {
  width 100%
  margin 0 40px
  overflow hidden

  &__body {
    height 100%
    padding 0
  }

  .ymap-container {
    width 100%
    height 100%
  }
}
</style>
